export const getQueryConfig = (staleTimeMs: number) => ({
  staleTime: staleTimeMs + Math.random() * staleTimeMs,
});
